import { Link } from 'gatsby';
import React from 'react';

const Domain = ({ link }) => {
  return (
    <div className="mt-16 relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto lg:max-w-5xl">
        <div className="absolute inset-x-0 top-0 transform translate-y-px">
          <div className="flex justify-center transform -translate-y-1/2">
            <span className="inline-flex rounded-full bg-indigo-600 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white">
              Domain License
            </span>
          </div>
        </div>
        <div className="rounded-lg bg-gray-100 px-6 py-8 sm:p-10 lg:flex lg:items-center  border-2 border-indigo-600">
          <div className="flex-1">
            <div className="mt-4 text-lg leading-7 text-gray-600">
              Purchase a domain license and enable premium features for everyone
              in your organization. Recommended for schools and businesses.
              <p className="mt-2 text-base text-gray-500">
                Compatible with all&nbsp;
                <strong className="font-semibold">
                  Google Workspace domains
                </strong>
                .
              </p>
            </div>
          </div>
          <div className="mt-6 rounded-md shadow lg:mt-0 lg:ml-10 lg:flex-shrink-0 ">
            <Link
              to={link}
              className="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-gray-900 bg-white hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out"
            >
              Buy Domain License
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Domain;
